import { Fragment } from 'react';
import { Report } from '@mui/icons-material'

import { Text } from '../../FormControls/Text';
import { Input } from '../../FormControls/Input';
import { Stack } from '../../FormControls/Stack';
import { ScreenControl } from '../ScreenControl';

import { useDispatch, useSelector } from 'react-redux'
import { checkForUser, setEmail } from '../../../../main/slices/userSlice';

export const Email = ({ dimensions }) => {

    const state = useSelector(({ user }) => user.email);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        // IF THE EMAIL DOES NOT MATCH THE REGEX
        if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(e))
            dispatch(setEmail({ value: e, error: true }));

        // IF THE EMAIL IS CORRECT
        else dispatch(setEmail({ value: e, error: false }));
    }

    const check = async () => {
        if (!state.error) return await dispatch(checkForUser())
            .unwrap()
            .then(() => true)
            .catch(e => false);

        else return false;
    }

    return (
        <Fragment>
            <Stack
                flex={{
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}
                sx={{ ...dimensions }}
            >

                {/* SCREEN LEGENDS */}
                <Text classes={["subtitle"]}> Hola, te damos la bienvenida </Text>
                <Text classes={["title"]}> Ingresa con tu correo </Text>

                {//INVALIR EMAIL ALERT
                    (state.error && state.value) &&
                    <Text classes={["description", "alignContent", "error"]} style={{ "justifyContent": "flex-start", "margin": "0.5em 0" }}>
                        <Report sx={{ fontSize: "1em", margin: "0 0.5em" }}></Report>
                        Correo electronico no válido
                    </Text>
                }

                {/* EMAIL INPUT */}
                <Input
                    type="email"
                    classes={[state.error && state.value ? "error" : ""]}
                    placeHolder="Correo electronico"
                    attributes={{ value: state.value }}
                    onChange={({ target }) => handleChange(target.value)}
                />

            </Stack>

            <ScreenControl
                disabled={state.error}
                beforeSubmit={() => check()}
            ></ScreenControl>
        </Fragment>
    );
}